import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonsTranslations } from '../buttons-translations.service';
import { SpinnerService } from '../spinner/spinner.service';

/**
 * Commponent for submit rows
 */
@Component({
  selector: 'app-submit-row-buttons',
  templateUrl: './submit-row-buttons.component.html'
})
export class SubmitRowButtonsComponent {
  @Input() public cancelButtonText: string = this.translations.i18nCancel;
  @Input() public submitButtonText: string = this.translations.i18nSubmit;
  @Input() public isFieldValid: boolean = true;
  @Input() public useIcon: boolean = false;
  @Input() public form: string = null;
  @Input() public spinnerName: string;

  @Input() public showSubmit: boolean = true;
  @Input() public showCancel: boolean = true;

  @Output() public cancelButton: EventEmitter<string> = new EventEmitter<string>();
  @Output() public submitButton: EventEmitter<string> = new EventEmitter<string>();

  constructor(private translations: ButtonsTranslations, private spinnerService: SpinnerService) {}

  /**
   * Clicking the back button will emit value 'clicked'
   */
  public cancelButtonClicked(): void {
    this.cancelButton.emit('clicked');
  }

  /**
   * Clicking the submit button will emit value 'clicked'
   */
  public submitButtonClicked(): void {
    this.submitButton.emit('clicked');
  }

  get showSpinner(): boolean {
    return this.spinnerService.isShowing(this.spinnerName);
  }

}
